import { ReactNode } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { NodeData } from '@contentful/rich-text-types';

const analytics =
  typeof window !== 'undefined' ? new AnalyticsBrowser() : undefined;

analytics?.load({ writeKey: process?.env?.NEXT_PUBLIC_SEGMENT_KEY || '' });

export { analytics };

export const analyticsLinkEvent = (data: NodeData, children: ReactNode) => {
  if (data.uri.startsWith('mailto:'))
    return analytics?.track('Email Link Clicked', {
      linkUrl: data.uri,
      linkText: children ? children[0] : '',
    });
  else if (data.uri.startsWith('tel:'))
    return analytics?.track('Phone Number Link Clicked', {
      link: children ? children[0] : '',
    });
  else
    return analytics?.track('CTA Clicked', {
      isNav: true,
      type: 'button',
      text: children ? children[0] : '',
    });
};
